/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Wetnotes API - dives management
 * Client application needs to check user's status every time when user login. According to a result client app provides a registration or an access to user's data.
 *
 * OpenAPI spec version: wetnotes
 * Contact: pavel.stejskal@outlook.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as url from 'url';
import { Configuration } from './configuration';
import 'url-search-params-polyfill';

export const BASE_PATH = (window as any).__REACT_SETTINGS.apiHostUrl.replace(
    /\/+$/,
    ''
);

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ',',
    ssv: ' ',
    tsv: '\t',
    pipes: '|'
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(
        configuration?: Configuration,
        protected basePath: string = BASE_PATH
    ) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: 'RequiredError';
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 *
 * @export
 * @interface CeilingRow
 */
export interface CeilingRow {
    /**
     *
     * @type {number}
     * @memberof CeilingRow
     */
    timestamp?: number;
    /**
     *
     * @type {number}
     * @memberof CeilingRow
     */
    ceiling?: number;
}

/**
 *
 * @export
 * @interface ChangePasswordDTO
 */
export interface ChangePasswordDTO {
    /**
     *
     * @type {string}
     * @memberof ChangePasswordDTO
     */
    password: string;
    /**
     *
     * @type {string}
     * @memberof ChangePasswordDTO
     */
    passwordConfirmation: string;
}

/**
 *
 * @export
 * @interface DepthRow
 */
export interface DepthRow {
    /**
     *
     * @type {number}
     * @memberof DepthRow
     */
    timestamp?: number;
    /**
     *
     * @type {number}
     * @memberof DepthRow
     */
    value?: number;
}

/**
 *
 * @export
 * @interface Dive
 */
export interface Dive {
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    userId?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    deviceSerial?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    thumbnail?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    location?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    site?: string;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    latitude?: number;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    longitude?: number;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    partner?: string;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    weather?: Dive.WeatherEnum;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    surfaceTemp?: number;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    salinity?: Dive.SalinityEnum;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    visibility?: number;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    weight?: number;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    maxDepth?: number;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    averageDepth?: number;
    /**
     *
     * @type {string}
     * @memberof Dive
     */
    duration?: string;
    /**
     *
     * @type {Date}
     * @memberof Dive
     */
    startDate?: Date;
    /**
     *
     * @type {Date}
     * @memberof Dive
     */
    dateUploaded?: Date;
    /**
     *
     * @type {number}
     * @memberof Dive
     */
    serial?: number;
    /**
     *
     * @type {Array&lt;string&gt;}
     * @memberof Dive
     */
    diveType?: Array<Dive.DiveTypeEnum>;
    /**
     *
     * @type {boolean}
     * @memberof Dive
     */
    reparsingNeeded?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Dive
     */
    sourceDataUnknown?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Dive
     */
    sourceDataModified?: boolean;
    /**
     *
     * @type {PotentialMockOfDouble}
     * @memberof Dive
     */
    sac?: PotentialMockOfDouble;
}

/**
 * @export
 * @namespace Dive
 */
export namespace Dive {
    /**
     * @export
     * @enum {string}
     */
    export enum WeatherEnum {
        Unknown = <any>'unknown',
        Clear = <any>'clear',
        PartyCloudy = <any>'partyCloudy',
        Cloudy = <any>'cloudy',
        Windy = <any>'windy',
        Rain = <any>'rain',
        Snow = <any>'snow',
        Storm = <any>'storm'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalinityEnum {
        Unknown = <any>'unknown',
        SeaWater = <any>'seaWater',
        FreshWater = <any>'freshWater',
        Mixed = <any>'mixed'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DiveTypeEnum {
        Unknown = <any>'unknown',
        Sightseeing = <any>'sightseeing',
        Training = <any>'training',
        Course = <any>'course',
        Teaching = <any>'teaching',
        ClubDive = <any>'clubDive',
        NightDive = <any>'nightDive',
        IceDive = <any>'iceDive',
        CaveDive = <any>'caveDive',
        CavernDive = <any>'cavernDive',
        WreckDive = <any>'wreckDive',
        DriftDive = <any>'driftDive',
        RiverDive = <any>'riverDive',
        Exploration = <any>'exploration',
        ScientificDive = <any>'scientificDive',
        CommercialDive = <any>'commercialDive',
        Other = <any>'other'
    }
}

/**
 * Class representing a bind model to DiveAndMixes
 * @export
 * @interface DiveAndMixesDTO
 */
export interface DiveAndMixesDTO {
    /**
     * Full dive object
     * @type {Dive}
     * @memberof DiveAndMixesDTO
     */
    dive?: Dive;
    /**
     * Full mixes info
     * @type {Array&lt;DiveMix&gt;}
     * @memberof DiveAndMixesDTO
     */
    mixes?: Array<DiveMix>;
}

/**
 * Class representing an editable object for user
 * @export
 * @interface DiveAndMixesEditDTO
 */
export interface DiveAndMixesEditDTO {
    /**
     * Class with editable properties for dive
     * @type {DiveEditDTO}
     * @memberof DiveAndMixesEditDTO
     */
    dive?: DiveEditDTO;
    /**
     * Class with editable properties for mixes
     * @type {Array&lt;DiveMixEditDTO&gt;}
     * @memberof DiveAndMixesEditDTO
     */
    mixes?: Array<DiveMixEditDTO>;
}

/**
 * Parsed data from Dive log and confirmation model
 * @export
 * @interface DiveAndMixesLogResultDTO
 */
export interface DiveAndMixesLogResultDTO {
    /**
     *
     * @type {DiveAndMixesDTO}
     * @memberof DiveAndMixesLogResultDTO
     */
    diveAndMixes?: DiveAndMixesDTO;
    /**
     *
     * @type {DiveAndMixesEditDTO}
     * @memberof DiveAndMixesLogResultDTO
     */
    diveAndMixesConfirmation?: DiveAndMixesEditDTO;
}

/**
 *
 * @export
 * @interface DiveComment
 */
export interface DiveComment {
    /**
     *
     * @type {Date}
     * @memberof DiveComment
     */
    dateCreated?: Date;
    /**
     *
     * @type {string}
     * @memberof DiveComment
     */
    text?: string;
    /**
     *
     * @type {string}
     * @memberof DiveComment
     */
    user?: string;
}

/**
 * Class representing a basic comment
 * @export
 * @interface DiveCommentEditableDTO
 */
export interface DiveCommentEditableDTO {
    /**
     * User's comment
     * @type {string}
     * @memberof DiveCommentEditableDTO
     */
    comment?: string;
}

/**
 *
 * @export
 * @interface DiveDetailDTO
 */
export interface DiveDetailDTO {
    /**
     *
     * @type {DiveAndMixesDTO}
     * @memberof DiveDetailDTO
     */
    diveAndMixes?: DiveAndMixesDTO;
    /**
     *
     * @type {InterfaceData}
     * @memberof DiveDetailDTO
     */
    diveData?: InterfaceData;
    /**
     *
     * @type {Array&lt;DiveComment&gt;}
     * @memberof DiveDetailDTO
     */
    comments?: Array<DiveComment>;
}

/**
 * Class representing an editable model for Dive
 * @export
 * @interface DiveEditDTO
 */
export interface DiveEditDTO {
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    deviceId?: string;
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    location?: string;
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    site?: string;
    /**
     *
     * @type {number}
     * @memberof DiveEditDTO
     */
    latitude?: number;
    /**
     *
     * @type {number}
     * @memberof DiveEditDTO
     */
    longitude?: number;
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    partner?: string;
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    weather?: DiveEditDTO.WeatherEnum;
    /**
     *
     * @type {number}
     * @memberof DiveEditDTO
     */
    surfaceTemp?: number;
    /**
     *
     * @type {string}
     * @memberof DiveEditDTO
     */
    salinity?: DiveEditDTO.SalinityEnum;
    /**
     *
     * @type {number}
     * @memberof DiveEditDTO
     */
    visibility?: number;
    /**
     *
     * @type {number}
     * @memberof DiveEditDTO
     */
    weight?: number;
    /**
     *
     * @type {Array&lt;string&gt;}
     * @memberof DiveEditDTO
     */
    diveType?: Array<DiveEditDTO.DiveTypeEnum>;
}

/**
 * @export
 * @namespace DiveEditDTO
 */
export namespace DiveEditDTO {
    /**
     * @export
     * @enum {string}
     */
    export enum WeatherEnum {
        Unknown = <any>'unknown',
        Clear = <any>'clear',
        PartyCloudy = <any>'partyCloudy',
        Cloudy = <any>'cloudy',
        Windy = <any>'windy',
        Rain = <any>'rain',
        Snow = <any>'snow',
        Storm = <any>'storm'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalinityEnum {
        Unknown = <any>'unknown',
        SeaWater = <any>'seaWater',
        FreshWater = <any>'freshWater',
        Mixed = <any>'mixed'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DiveTypeEnum {
        Unknown = <any>'unknown',
        Sightseeing = <any>'sightseeing',
        Training = <any>'training',
        Course = <any>'course',
        Teaching = <any>'teaching',
        ClubDive = <any>'clubDive',
        NightDive = <any>'nightDive',
        IceDive = <any>'iceDive',
        CaveDive = <any>'caveDive',
        CavernDive = <any>'cavernDive',
        WreckDive = <any>'wreckDive',
        DriftDive = <any>'driftDive',
        RiverDive = <any>'riverDive',
        Exploration = <any>'exploration',
        ScientificDive = <any>'scientificDive',
        CommercialDive = <any>'commercialDive',
        Other = <any>'other'
    }
}

/**
 *
 * @export
 * @interface DiveMix
 */
export interface DiveMix {
    /**
     *
     * @type {number}
     * @memberof DiveMix
     */
    id?: number;
    /**
     *
     * @type {string}
     * @memberof DiveMix
     */
    o2?: string;
    /**
     *
     * @type {string}
     * @memberof DiveMix
     */
    he?: string;
    /**
     *
     * @type {number}
     * @memberof DiveMix
     */
    startPressure?: number;
    /**
     *
     * @type {number}
     * @memberof DiveMix
     */
    endPressure?: number;
    /**
     *
     * @type {number}
     * @memberof DiveMix
     */
    tankVolume?: number;
    /**
     *
     * @type {string}
     * @memberof DiveMix
     */
    mixType?: DiveMix.MixTypeEnum;
}

/**
 * @export
 * @namespace DiveMix
 */
export namespace DiveMix {
    /**
     * @export
     * @enum {string}
     */
    export enum MixTypeEnum {
        Air = <any>'air',
        Trimix = <any>'trimix',
        Ean = <any>'ean',
        Oxygen = <any>'oxygen'
    }
}

/**
 *
 * @export
 * @interface DiveMixEditDTO
 */
export interface DiveMixEditDTO {
    /**
     *
     * @type {number}
     * @memberof DiveMixEditDTO
     */
    id?: number;
    /**
     *
     * @type {number}
     * @memberof DiveMixEditDTO
     */
    startPressure?: number;
    /**
     *
     * @type {number}
     * @memberof DiveMixEditDTO
     */
    endPressure?: number;
    /**
     *
     * @type {number}
     * @memberof DiveMixEditDTO
     */
    tankVolume?: number;
}

/**
 *
 * @export
 * @interface DiveSharingTokenDto
 */
export interface DiveSharingTokenDto {
    /**
     *
     * @type {string}
     * @memberof DiveSharingTokenDto
     */
    tokenId?: string;
    /**
     *
     * @type {string}
     * @memberof DiveSharingTokenDto
     */
    validity?: string;
    /**
     *
     * @type {string}
     * @memberof DiveSharingTokenDto
     */
    diveId?: string;
}

/**
 *
 * @export
 * @interface DivesListDTO
 */
export interface DivesListDTO {
    /**
     *
     * @type {UserDiveListDTO}
     * @memberof DivesListDTO
     */
    items?: UserDiveListDTO;
}

/**
 *
 * @export
 * @interface EventRow
 */
export interface EventRow {
    /**
     *
     * @type {number}
     * @memberof EventRow
     */
    timestamp?: number;
    /**
     *
     * @type {string}
     * @memberof EventRow
     */
    type?: string;
    /**
     *
     * @type {string}
     * @memberof EventRow
     */
    subType?: string;
    /**
     *
     * @type {string}
     * @memberof EventRow
     */
    description?: string;
}

/**
 *
 * @export
 * @interface GeneralError
 */
export interface GeneralError {
    /**
     * Free text describing an error
     * @type {string}
     * @memberof GeneralError
     */
    errorText?: string;
    /**
     * Optional error code - 2xx OK, 4xx error as HttpStatus codes
     * @type {number}
     * @memberof GeneralError
     */
    errorCode?: number;
    /**
     * Returned data if needed
     * @type {any}
     * @memberof GeneralError
     */
    resultData?: any;
}

/**
 * Class representing a general response
 * @export
 * @interface GeneralResponse
 */
export interface GeneralResponse {
    /**
     * Main response
     * @type {string}
     * @memberof GeneralResponse
     */
    response?: string;
    /**
     * Optional response code
     * @type {number}
     * @memberof GeneralResponse
     */
    responseCode?: number;
    /**
     * Additional message
     * @type {string}
     * @memberof GeneralResponse
     */
    message?: string;
}

/**
 *
 * @export
 * @interface GraphData
 */
export interface GraphData {
    /**
     *
     * @type {Array&lt;DepthRow&gt;}
     * @memberof GraphData
     */
    depth?: Array<DepthRow>;
    /**
     *
     * @type {Array&lt;ModeRow&gt;}
     * @memberof GraphData
     */
    modes?: Array<ModeRow>;
    /**
     *
     * @type {Array&lt;MixRow&gt;}
     * @memberof GraphData
     */
    mixes?: Array<MixRow>;
    /**
     *
     * @type {Array&lt;TemperatureRow&gt;}
     * @memberof GraphData
     */
    temperature?: Array<TemperatureRow>;
    /**
     *
     * @type {Array&lt;CeilingRow&gt;}
     * @memberof GraphData
     */
    ceiling?: Array<CeilingRow>;
    /**
     *
     * @type {Array&lt;SetpointRow&gt;}
     * @memberof GraphData
     */
    setpoint?: Array<SetpointRow>;
    /**
     *
     * @type {Array&lt;PpO2Row&gt;}
     * @memberof GraphData
     */
    ppo2?: Array<PpO2Row>;
}

/**
 *
 * @export
 * @interface InterfaceData
 */
export interface InterfaceData {
    /**
     *
     * @type {number}
     * @memberof InterfaceData
     */
    avgDepth?: number;
    /**
     *
     * @type {string}
     * @memberof InterfaceData
     */
    startMode?: InterfaceData.StartModeEnum;
    /**
     *
     * @type {Array&lt;EventRow&gt;}
     * @memberof InterfaceData
     */
    events?: Array<EventRow>;
    /**
     *
     * @type {GraphData}
     * @memberof InterfaceData
     */
    graphData?: GraphData;
}

/**
 * @export
 * @namespace InterfaceData
 */
export namespace InterfaceData {
    /**
     * @export
     * @enum {string}
     */
    export enum StartModeEnum {
        Unknown = <any>'unknown',
        Oc = <any>'oc',
        Ccr = <any>'ccr',
        MCcr = <any>'mCcr',
        Free = <any>'free',
        Gauge = <any>'gauge',
        Ascr = <any>'ascr',
        Pscr = <any>'pscr'
    }
}

/**
 *
 * @export
 * @interface MixRow
 */
export interface MixRow {
    /**
     *
     * @type {number}
     * @memberof MixRow
     */
    timestamp?: number;
    /**
     *
     * @type {string}
     * @memberof MixRow
     */
    mixHe?: string;
    /**
     *
     * @type {string}
     * @memberof MixRow
     */
    mixO2?: string;
    /**
     *
     * @type {string}
     * @memberof MixRow
     */
    mixType?: MixRow.MixTypeEnum;
}

/**
 * @export
 * @namespace MixRow
 */
export namespace MixRow {
    /**
     * @export
     * @enum {string}
     */
    export enum MixTypeEnum {
        Air = <any>'air',
        Trimix = <any>'trimix',
        Ean = <any>'ean',
        Oxygen = <any>'oxygen'
    }
}

/**
 *
 * @export
 * @interface ModeRow
 */
export interface ModeRow {
    /**
     *
     * @type {number}
     * @memberof ModeRow
     */
    timestamp?: number;
    /**
     *
     * @type {string}
     * @memberof ModeRow
     */
    mode?: ModeRow.ModeEnum;
}

/**
 * @export
 * @namespace ModeRow
 */
export namespace ModeRow {
    /**
     * @export
     * @enum {string}
     */
    export enum ModeEnum {
        Unknown = <any>'unknown',
        Oc = <any>'oc',
        Ccr = <any>'ccr',
        MCcr = <any>'mCcr',
        Free = <any>'free',
        Gauge = <any>'gauge',
        Ascr = <any>'ascr',
        Pscr = <any>'pscr'
    }
}

/**
 *
 * @export
 * @interface PotentialMockOfDouble
 */
export interface PotentialMockOfDouble {
    /**
     *
     * @type {boolean}
     * @memberof PotentialMockOfDouble
     */
    isInvalid?: boolean;
    /**
     *
     * @type {number}
     * @memberof PotentialMockOfDouble
     */
    value?: number;
    /**
     *
     * @type {boolean}
     * @memberof PotentialMockOfDouble
     */
    sourceDataInvalid?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PotentialMockOfDouble
     */
    sourceDataIncomplete?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PotentialMockOfDouble
     */
    isValueValid?: boolean;
}

/**
 *
 * @export
 * @interface PpO2Row
 */
export interface PpO2Row {
    /**
     *
     * @type {number}
     * @memberof PpO2Row
     */
    timestamp?: number;
    /**
     *
     * @type {number}
     * @memberof PpO2Row
     */
    pressureInBar?: number;
}

/**
 *
 * @export
 * @interface ProfileDTO
 */
export interface ProfileDTO {
    /**
     *
     * @type {UserBasicInfoDTO}
     * @memberof ProfileDTO
     */
    userBasicInfo?: UserBasicInfoDTO;
    /**
     *
     * @type {UserSettingsDTO}
     * @memberof ProfileDTO
     */
    userSettings?: UserSettingsDTO;
}

/**
 * Registration model
 * @export
 * @interface RegistrationDTO
 */
export interface RegistrationDTO {
    /**
     *
     * @type {string}
     * @memberof RegistrationDTO
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof RegistrationDTO
     */
    surname: string;
    /**
     *
     * @type {string}
     * @memberof RegistrationDTO
     */
    contactEmail: string;
    /**
     *
     * @type {boolean}
     * @memberof RegistrationDTO
     */
    conditionsApproved: boolean;
}

/**
 *
 * @export
 * @interface SetpointRow
 */
export interface SetpointRow {
    /**
     *
     * @type {number}
     * @memberof SetpointRow
     */
    timestamp?: number;
    /**
     *
     * @type {number}
     * @memberof SetpointRow
     */
    pressureInBar?: number;
}

/**
 *
 * @export
 * @interface TemperatureRow
 */
export interface TemperatureRow {
    /**
     *
     * @type {number}
     * @memberof TemperatureRow
     */
    timestamp?: number;
    /**
     *
     * @type {number}
     * @memberof TemperatureRow
     */
    temperature?: number;
}

/**
 *
 * @export
 * @interface UserBasicInfoDTO
 */
export interface UserBasicInfoDTO {
    /**
     *
     * @type {Date}
     * @memberof UserBasicInfoDTO
     */
    dateRegistered?: Date;
    /**
     *
     * @type {string}
     * @memberof UserBasicInfoDTO
     */
    name: string;
    /**
     *
     * @type {string}
     * @memberof UserBasicInfoDTO
     */
    surname: string;
    /**
     *
     * @type {string}
     * @memberof UserBasicInfoDTO
     */
    nickname?: string;
    /**
     *
     * @type {string}
     * @memberof UserBasicInfoDTO
     */
    contactEmail: string;
}

/**
 *
 * @export
 * @interface UserDiveListDTO
 */
export interface UserDiveListDTO {
    /**
     *
     * @type {Array&lt;UserDiveListEntryDTO&gt;}
     * @memberof UserDiveListDTO
     */
    userDives?: Array<UserDiveListEntryDTO>;
    /**
     *
     * @type {Array&lt;UserDiveListEntryDTO&gt;}
     * @memberof UserDiveListDTO
     */
    sharedDives?: Array<UserDiveListEntryDTO>;
}

/**
 *
 * @export
 * @interface UserDiveListEntryDTO
 */
export interface UserDiveListEntryDTO {
    /**
     * Dive Id
     * @type {string}
     * @memberof UserDiveListEntryDTO
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof UserDiveListEntryDTO
     */
    user?: string;
    /**
     *
     * @type {string}
     * @memberof UserDiveListEntryDTO
     */
    deviceId?: string;
    /**
     * Not needed in Wetnotes
     * @type {number}
     * @memberof UserDiveListEntryDTO
     */
    latitude?: number;
    /**
     *
     * @type {number}
     * @memberof UserDiveListEntryDTO
     */
    longitude?: number;
    /**
     *
     * @type {number}
     * @memberof UserDiveListEntryDTO
     */
    maxDepth?: number;
    /**
     *
     * @type {string}
     * @memberof UserDiveListEntryDTO
     */
    duration?: string;
    /**
     *
     * @type {Date}
     * @memberof UserDiveListEntryDTO
     */
    startDate?: Date;
    /**
     *
     * @type {number}
     * @memberof UserDiveListEntryDTO
     */
    serial?: number;
    /**
     *
     * @type {string}
     * @memberof UserDiveListEntryDTO
     */
    location?: string;
}

/**
 *
 * @export
 * @interface UserSettingsDTO
 */
export interface UserSettingsDTO {
    /**
     *
     * @type {number}
     * @memberof UserSettingsDTO
     */
    diveStartNumber?: number;
    /**
     *
     * @type {string}
     * @memberof UserSettingsDTO
     */
    unitOfLength?: UserSettingsDTO.UnitOfLengthEnum;
    /**
     *
     * @type {string}
     * @memberof UserSettingsDTO
     */
    unitOfMass?: UserSettingsDTO.UnitOfMassEnum;
    /**
     *
     * @type {string}
     * @memberof UserSettingsDTO
     */
    unitOfPressure?: UserSettingsDTO.UnitOfPressureEnum;
    /**
     *
     * @type {string}
     * @memberof UserSettingsDTO
     */
    unitOfTemperature?: UserSettingsDTO.UnitOfTemperatureEnum;
    /**
     *
     * @type {string}
     * @memberof UserSettingsDTO
     */
    unitOfVolume?: UserSettingsDTO.UnitOfVolumeEnum;
    /**
     *
     * @type {string}
     * @memberof UserSettingsDTO
     */
    dateFormat?: UserSettingsDTO.DateFormatEnum;
}

/**
 * @export
 * @namespace UserSettingsDTO
 */
export namespace UserSettingsDTO {
    /**
     * @export
     * @enum {string}
     */
    export enum UnitOfLengthEnum {
        Unknown = <any>'unknown',
        Metre = <any>'metre',
        Foot = <any>'foot'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UnitOfMassEnum {
        Unknown = <any>'unknown',
        Kilogram = <any>'kilogram',
        Pound = <any>'pound'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UnitOfPressureEnum {
        Unknown = <any>'unknown',
        Bar = <any>'bar',
        PoundPerSquareInch = <any>'poundPerSquareInch'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UnitOfTemperatureEnum {
        Unknown = <any>'unknown',
        Celsius = <any>'celsius',
        Fahrenheit = <any>'fahrenheit'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum UnitOfVolumeEnum {
        Unknown = <any>'unknown',
        Liter = <any>'liter',
        CubicFoot = <any>'cubicFoot'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DateFormatEnum {
        DMY = <any>'dMY',
        YMD = <any>'yMD',
        MDY = <any>'mDY'
    }
}

/**
 * DivesApi - fetch parameter creator
 * @export
 */
export const DivesApiFetchParamCreator = function(
    configuration?: Configuration
) {
    return {
        /**
         *
         * @summary Adds comment to dive
         * @param {string} id ID of dive
         * @param {DiveCommentEditableDTO} [diveComment] Comment model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdCommentsPost(
            id: string,
            diveComment?: DiveCommentEditableDTO,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling apiDivesByIdCommentsPost.'
                );
            }
            const localVarPath = `/api/dives/{id}/comments`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'DiveCommentEditableDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(diveComment || {})
                : diveComment || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Delete user's dive
         * @param {string} id ID of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdDelete(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling apiDivesByIdDelete.'
                );
            }
            const localVarPath = `/api/dives/{id}`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'DELETE' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Returns the detailed information about the dive with this ID.
         * @param {string} id Id of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdGet(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling apiDivesByIdGet.'
                );
            }
            const localVarPath = `/api/dives/{id}`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'GET' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         * That means the newly created dive will be available in the user’s list.
         * @summary Confirms the dive with this ID.
         * @param {string} id
         * @param {DiveAndMixesEditDTO} [diveAndMixesEdit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdPost(
            id: string,
            diveAndMixesEdit?: DiveAndMixesEditDTO,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling apiDivesByIdPost.'
                );
            }
            const localVarPath = `/api/dives/{id}`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'DiveAndMixesEditDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(diveAndMixesEdit || {})
                : diveAndMixesEdit || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Updates the dive with this ID.
         * @param {string} id ID of dive
         * @param {DiveAndMixesEditDTO} [diveAndMixesEdit] Dive information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdPut(
            id: string,
            diveAndMixesEdit?: DiveAndMixesEditDTO,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling apiDivesByIdPut.'
                );
            }
            const localVarPath = `/api/dives/{id}`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'PUT' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'DiveAndMixesEditDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(diveAndMixesEdit || {})
                : diveAndMixesEdit || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Creates a sharing token for dive
         * @param {string} id Id of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdSharingTokensPost(
            id: string,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError(
                    'id',
                    'Required parameter id was null or undefined when calling apiDivesByIdSharingTokensPost.'
                );
            }
            const localVarPath = `/api/dives/{id}/sharingTokens`.replace(
                `{${'id'}}`,
                encodeURIComponent(String(id))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         * Only the basic information is returned.
         * @summary Returns the list of the dives belonging to the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesGet(options: any = {}): FetchArgs {
            const localVarPath = `/api/dives`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'GET' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         * Creates the dive and leaves it unconfirmed. Parses the dive log and presents the available information.
         * @summary The first step of the 2-step dive creation.
         * @param {any} file Uplaod Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesPost(file: any, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError(
                    'file',
                    'Required parameter file was null or undefined when calling apiDivesPost.'
                );
            }
            const localVarPath = `/api/dives`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            const localVarFormParams = new FormData();

            if (file !== undefined) {
                localVarFormParams.append('File', file as any);
            }


            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            localVarRequestOptions.body = localVarFormParams;

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * DivesApi - functional programming interface
 * @export
 */
export const DivesApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Adds comment to dive
         * @param {string} id ID of dive
         * @param {DiveCommentEditableDTO} [diveComment] Comment model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdCommentsPost(
            id: string,
            diveComment?: DiveCommentEditableDTO,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesByIdCommentsPost(id, diveComment, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Delete user's dive
         * @param {string} id ID of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdDelete(
            id: string,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesByIdDelete(id, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns the detailed information about the dive with this ID.
         * @param {string} id Id of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdGet(
            id: string,
            options?: any
        ): (basePath?: string) => Promise<DiveDetailDTO> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesByIdGet(id, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * That means the newly created dive will be available in the user’s list.
         * @summary Confirms the dive with this ID.
         * @param {string} id
         * @param {DiveAndMixesEditDTO} [diveAndMixesEdit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdPost(
            id: string,
            diveAndMixesEdit?: DiveAndMixesEditDTO,
            options?: any
        ): (basePath?: string) => Promise<GeneralResponse> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesByIdPost(id, diveAndMixesEdit, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates the dive with this ID.
         * @param {string} id ID of dive
         * @param {DiveAndMixesEditDTO} [diveAndMixesEdit] Dive information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdPut(
            id: string,
            diveAndMixesEdit?: DiveAndMixesEditDTO,
            options?: any
        ): (basePath?: string) => Promise<GeneralResponse> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesByIdPut(id, diveAndMixesEdit, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Creates a sharing token for dive
         * @param {string} id Id of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdSharingTokensPost(
            id: string,
            options?: any
        ): (basePath?: string) => Promise<DiveSharingTokenDto> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesByIdSharingTokensPost(id, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Only the basic information is returned.
         * @summary Returns the list of the dives belonging to the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesGet(
            options?: any
        ): (basePath?: string) => Promise<DivesListDTO> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesGet(options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Creates the dive and leaves it unconfirmed. Parses the dive log and presents the available information.
         * @summary The first step of the 2-step dive creation.
         * @param {any} file Uplaod Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesPost(
            file: any,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DivesApiFetchParamCreator(
                configuration
            ).apiDivesPost(file, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    ...localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        }
    };
};

/**
 * DivesApi - factory interface
 * @export
 */
export const DivesApiFactory = function(
    configuration?: Configuration,
    basePath?: string
) {
    return {
        /**
         *
         * @summary Adds comment to dive
         * @param {string} id ID of dive
         * @param {DiveCommentEditableDTO} [diveComment] Comment model
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdCommentsPost(
            id: string,
            diveComment?: DiveCommentEditableDTO,
            options?: any
        ) {
            return DivesApiFp(configuration).apiDivesByIdCommentsPost(
                id,
                diveComment,
                options
            )(basePath);
        },
        /**
         *
         * @summary Delete user's dive
         * @param {string} id ID of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdDelete(id: string, options?: any) {
            return DivesApiFp(configuration).apiDivesByIdDelete(id, options)(
                basePath
            );
        },
        /**
         *
         * @summary Returns the detailed information about the dive with this ID.
         * @param {string} id Id of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdGet(id: string, options?: any) {
            return DivesApiFp(configuration).apiDivesByIdGet(id, options)(
                basePath
            );
        },
        /**
         * That means the newly created dive will be available in the user’s list.
         * @summary Confirms the dive with this ID.
         * @param {string} id
         * @param {DiveAndMixesEditDTO} [diveAndMixesEdit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdPost(
            id: string,
            diveAndMixesEdit?: DiveAndMixesEditDTO,
            options?: any
        ) {
            return DivesApiFp(configuration).apiDivesByIdPost(
                id,
                diveAndMixesEdit,
                options
            )(basePath);
        },
        /**
         *
         * @summary Updates the dive with this ID.
         * @param {string} id ID of dive
         * @param {DiveAndMixesEditDTO} [diveAndMixesEdit] Dive information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdPut(
            id: string,
            diveAndMixesEdit?: DiveAndMixesEditDTO,
            options?: any
        ) {
            return DivesApiFp(configuration).apiDivesByIdPut(
                id,
                diveAndMixesEdit,
                options
            )(basePath);
        },
        /**
         *
         * @summary Creates a sharing token for dive
         * @param {string} id Id of dive
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesByIdSharingTokensPost(id: string, options?: any) {
            return DivesApiFp(configuration).apiDivesByIdSharingTokensPost(
                id,
                options
            )(basePath);
        },
        /**
         * Only the basic information is returned.
         * @summary Returns the list of the dives belonging to the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesGet(options?: any) {
            return DivesApiFp(configuration).apiDivesGet(options)(basePath);
        },
        /**
         * Creates the dive and leaves it unconfirmed. Parses the dive log and presents the available information.
         * @summary The first step of the 2-step dive creation.
         * @param {any} file Uplaod Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDivesPost(file: any, options?: any) {
            return DivesApiFp(configuration).apiDivesPost(file, options)(
                basePath
            );
        }
    };
};

/**
 * DivesApi - object-oriented interface
 * @export
 * @class DivesApi
 * @extends {BaseAPI}
 */
export class DivesApi extends BaseAPI {
    /**
     *
     * @summary Adds comment to dive
     * @param {} id ID of dive
     * @param {} [diveComment] Comment model
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesByIdCommentsPost(
        id: string,
        diveComment?: DiveCommentEditableDTO,
        options?: any
    ) {
        return DivesApiFp(this.configuration).apiDivesByIdCommentsPost(
            id,
            diveComment,
            options
        )(this.basePath);
    }

    /**
     *
     * @summary Delete user's dive
     * @param {} id ID of dive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesByIdDelete(id: string, options?: any) {
        return DivesApiFp(this.configuration).apiDivesByIdDelete(id, options)(
            this.basePath
        );
    }

    /**
     *
     * @summary Returns the detailed information about the dive with this ID.
     * @param {} id Id of dive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesByIdGet(id: string, options?: any) {
        return DivesApiFp(this.configuration).apiDivesByIdGet(id, options)(
            this.basePath
        );
    }

    /**
     * That means the newly created dive will be available in the user’s list.
     * @summary Confirms the dive with this ID.
     * @param {} id
     * @param {} [diveAndMixesEdit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesByIdPost(
        id: string,
        diveAndMixesEdit?: DiveAndMixesEditDTO,
        options?: any
    ) {
        return DivesApiFp(this.configuration).apiDivesByIdPost(
            id,
            diveAndMixesEdit,
            options
        )(this.basePath);
    }

    /**
     *
     * @summary Updates the dive with this ID.
     * @param {} id ID of dive
     * @param {} [diveAndMixesEdit] Dive information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesByIdPut(
        id: string,
        diveAndMixesEdit?: DiveAndMixesEditDTO,
        options?: any
    ) {
        return DivesApiFp(this.configuration).apiDivesByIdPut(
            id,
            diveAndMixesEdit,
            options
        )(this.basePath);
    }

    /**
     *
     * @summary Creates a sharing token for dive
     * @param {} id Id of dive
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesByIdSharingTokensPost(id: string, options?: any) {
        return DivesApiFp(this.configuration).apiDivesByIdSharingTokensPost(
            id,
            options
        )(this.basePath);
    }

    /**
     * Only the basic information is returned.
     * @summary Returns the list of the dives belonging to the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesGet(options?: any) {
        return DivesApiFp(this.configuration).apiDivesGet(options)(
            this.basePath
        );
    }

    /**
     * Creates the dive and leaves it unconfirmed. Parses the dive log and presents the available information.
     * @summary The first step of the 2-step dive creation.
     * @param {} file Uplaod Image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DivesApi
     */
    public apiDivesPost(file: any, options?: any) {
        return DivesApiFp(this.configuration).apiDivesPost(file, options)(
            this.basePath
        );
    }
}

/**
 * ProfileApi - fetch parameter creator
 * @export
 */
export const ProfileApiFetchParamCreator = function(
    configuration?: Configuration
) {
    return {
        /**
         *
         * @summary Updates the user profile data.
         * @param {UserBasicInfoDTO} [basicInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileBasicInfoPut(
            basicInfo?: UserBasicInfoDTO,
            options: any = {}
        ): FetchArgs {
            const localVarPath = `/api/profile/basicInfo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'PUT' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'UserBasicInfoDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(basicInfo || {})
                : basicInfo || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Changes users password
         * @param {ChangePasswordDTO} [changePassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileChangePasswordPost(
            changePassword?: ChangePasswordDTO,
            options: any = {}
        ): FetchArgs {
            const localVarPath = `/api/profile/changePassword`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'ChangePasswordDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(changePassword || {})
                : changePassword || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         * Returns profile data or error if user is not registered
         * @summary Returns the user profile data and the user settings for the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileGet(options: any = {}): FetchArgs {
            const localVarPath = `/api/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'GET' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         * After successful registration SPA need to refresh auth token!
         * @summary Registers the new user with WetNotes.
         * @param {RegistrationDTO} [registration] Basic informations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfilePost(
            registration?: RegistrationDTO,
            options: any = {}
        ): FetchArgs {
            const localVarPath = `/api/profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'RegistrationDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(registration || {})
                : registration || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Updates user settings.
         * @param {UserSettingsDTO} [settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileSettingsPut(
            settings?: UserSettingsDTO,
            options: any = {}
        ): FetchArgs {
            const localVarPath = `/api/profile/settings`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'PUT' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );
            const needsSerialization =
                <any>'UserSettingsDTO' !== 'string' ||
                localVarRequestOptions.headers['Content-Type'] ===
                    'application/json';
            localVarRequestOptions.body = needsSerialization
                ? JSON.stringify(settings || {})
                : settings || '';

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Updates the user profile data.
         * @param {UserBasicInfoDTO} [basicInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileBasicInfoPut(
            basicInfo?: UserBasicInfoDTO,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(
                configuration
            ).apiProfileBasicInfoPut(basicInfo, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Changes users password
         * @param {ChangePasswordDTO} [changePassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileChangePasswordPost(
            changePassword?: ChangePasswordDTO,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(
                configuration
            ).apiProfileChangePasswordPost(changePassword, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Returns profile data or error if user is not registered
         * @summary Returns the user profile data and the user settings for the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileGet(
            options?: any
        ): (basePath?: string) => Promise<ProfileDTO> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(
                configuration
            ).apiProfileGet(options);

            // console.log(stuff);

            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * After successful registration SPA need to refresh auth token!
         * @summary Registers the new user with WetNotes.
         * @param {RegistrationDTO} [registration] Basic informations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfilePost(
            registration?: RegistrationDTO,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(
                configuration
            ).apiProfilePost(registration, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Updates user settings.
         * @param {UserSettingsDTO} [settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileSettingsPut(
            settings?: UserSettingsDTO,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ProfileApiFetchParamCreator(
                configuration
            ).apiProfileSettingsPut(settings, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        }
    };
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function(
    configuration?: Configuration,
    basePath?: string
) {
    return {
        /**
         *
         * @summary Updates the user profile data.
         * @param {UserBasicInfoDTO} [basicInfo]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileBasicInfoPut(basicInfo?: UserBasicInfoDTO, options?: any) {
            return ProfileApiFp(configuration).apiProfileBasicInfoPut(
                basicInfo,
                options
            )(basePath);
        },
        /**
         *
         * @summary Changes users password
         * @param {ChangePasswordDTO} [changePassword]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileChangePasswordPost(
            changePassword?: ChangePasswordDTO,
            options?: any
        ) {
            return ProfileApiFp(configuration).apiProfileChangePasswordPost(
                changePassword,
                options
            )(basePath);
        },
        /**
         * Returns profile data or error if user is not registered
         * @summary Returns the user profile data and the user settings for the currently authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileGet(options?: any) {
            return ProfileApiFp(configuration).apiProfileGet(options)(basePath);
        },
        /**
         * After successful registration SPA need to refresh auth token!
         * @summary Registers the new user with WetNotes.
         * @param {RegistrationDTO} [registration] Basic informations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfilePost(registration?: RegistrationDTO, options?: any) {
            return ProfileApiFp(configuration).apiProfilePost(
                registration,
                options
            )(basePath);
        },
        /**
         *
         * @summary Updates user settings.
         * @param {UserSettingsDTO} [settings]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProfileSettingsPut(settings?: UserSettingsDTO, options?: any) {
            return ProfileApiFp(configuration).apiProfileSettingsPut(
                settings,
                options
            )(basePath);
        }
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     *
     * @summary Updates the user profile data.
     * @param {} [basicInfo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiProfileBasicInfoPut(basicInfo?: UserBasicInfoDTO, options?: any) {
        return ProfileApiFp(this.configuration).apiProfileBasicInfoPut(
            basicInfo,
            options
        )(this.basePath);
    }

    /**
     *
     * @summary Changes users password
     * @param {} [changePassword]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiProfileChangePasswordPost(
        changePassword?: ChangePasswordDTO,
        options?: any
    ) {
        return ProfileApiFp(this.configuration).apiProfileChangePasswordPost(
            changePassword,
            options
        )(this.basePath);
    }

    /**
     * Returns profile data or error if user is not registered
     * @summary Returns the user profile data and the user settings for the currently authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiProfileGet(options?: any) {
        return ProfileApiFp(this.configuration).apiProfileGet(options)(
            this.basePath
        );
    }

    /**
     * After successful registration SPA need to refresh auth token!
     * @summary Registers the new user with WetNotes.
     * @param {} [registration] Basic informations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiProfilePost(registration?: RegistrationDTO, options?: any) {
        return ProfileApiFp(this.configuration).apiProfilePost(
            registration,
            options
        )(this.basePath);
    }

    /**
     *
     * @summary Updates user settings.
     * @param {} [settings]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public apiProfileSettingsPut(settings?: UserSettingsDTO, options?: any) {
        return ProfileApiFp(this.configuration).apiProfileSettingsPut(
            settings,
            options
        )(this.basePath);
    }
}

/**
 * SharedDivesApi - fetch parameter creator
 * @export
 */
export const SharedDivesApiFetchParamCreator = function(
    configuration?: Configuration
) {
    return {
        /**
         *
         * @summary Deletes a shared dive (connection to profile)
         * @param {string} diveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesByDiveIdDelete(
            diveId: string,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'diveId' is not null or undefined
            if (diveId === null || diveId === undefined) {
                throw new RequiredError(
                    'diveId',
                    'Required parameter diveId was null or undefined when calling apiSharedDivesByDiveIdDelete.'
                );
            }
            const localVarPath = `/api/sharedDives/{diveId}`.replace(
                `{${'diveId'}}`,
                encodeURIComponent(String(diveId))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'DELETE' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Returns a detail of shared dive
         * @param {string} diveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesByDiveIdGet(
            diveId: string,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'diveId' is not null or undefined
            if (diveId === null || diveId === undefined) {
                throw new RequiredError(
                    'diveId',
                    'Required parameter diveId was null or undefined when calling apiSharedDivesByDiveIdGet.'
                );
            }
            const localVarPath = `/api/sharedDives/{diveId}`.replace(
                `{${'diveId'}}`,
                encodeURIComponent(String(diveId))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'GET' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Creates a shared dive via sharedToken
         * @param {string} sharingToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesBySharingTokenPost(
            sharingToken: string,
            options: any = {}
        ): FetchArgs {
            // verify required parameter 'sharingToken' is not null or undefined
            if (sharingToken === null || sharingToken === undefined) {
                throw new RequiredError(
                    'sharingToken',
                    'Required parameter sharingToken was null or undefined when calling apiSharedDivesBySharingTokenPost.'
                );
            }
            const localVarPath = `/api/sharedDives/{sharingToken}`.replace(
                `{${'sharingToken'}}`,
                encodeURIComponent(String(sharingToken))
            );
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'POST' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        },
        /**
         *
         * @summary Returns a list of shared dives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesGet(options: any = {}): FetchArgs {
            const localVarPath = `/api/sharedDives`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign(
                { method: 'GET' },
                options
            );
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue =
                    typeof configuration.accessToken === 'function'
                        ? configuration.accessToken('oauth2', [])
                        : configuration.accessToken;
                localVarHeaderParameter['Authorization'] =
                    'Bearer ' + localVarAccessTokenValue;
            }

            localVarUrlObj.query = Object.assign(
                {},
                localVarUrlObj.query,
                localVarQueryParameter,
                options.query
            );
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign(
                {},
                localVarHeaderParameter,
                options.headers
            );

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions
            };
        }
    };
};

/**
 * SharedDivesApi - functional programming interface
 * @export
 */
export const SharedDivesApiFp = function(configuration?: Configuration) {
    return {
        /**
         *
         * @summary Deletes a shared dive (connection to profile)
         * @param {string} diveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesByDiveIdDelete(
            diveId: string,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SharedDivesApiFetchParamCreator(
                configuration
            ).apiSharedDivesByDiveIdDelete(diveId, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns a detail of shared dive
         * @param {string} diveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesByDiveIdGet(
            diveId: string,
            options?: any
        ): (basePath?: string) => Promise<DiveDetailDTO> {
            const localVarFetchArgs = SharedDivesApiFetchParamCreator(
                configuration
            ).apiSharedDivesByDiveIdGet(diveId, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Creates a shared dive via sharedToken
         * @param {string} sharingToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesBySharingTokenPost(
            sharingToken: string,
            options?: any
        ): (basePath?: string) => Promise<Response> {
            const localVarFetchArgs = SharedDivesApiFetchParamCreator(
                configuration
            ).apiSharedDivesBySharingTokenPost(sharingToken, options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Returns a list of shared dives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesGet(
            options?: any
        ): (basePath?: string) => Promise<DivesListDTO> {
            const localVarFetchArgs = SharedDivesApiFetchParamCreator(
                configuration
            ).apiSharedDivesGet(options);
            return (basePath: string = BASE_PATH) => {
                return fetch(
                    basePath + localVarFetchArgs.url,
                    localVarFetchArgs.options
                ).then(response => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        }
    };
};

/**
 * SharedDivesApi - factory interface
 * @export
 */
export const SharedDivesApiFactory = function(
    configuration?: Configuration,
    basePath?: string
) {
    return {
        /**
         *
         * @summary Deletes a shared dive (connection to profile)
         * @param {string} diveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesByDiveIdDelete(diveId: string, options?: any) {
            return SharedDivesApiFp(configuration).apiSharedDivesByDiveIdDelete(
                diveId,
                options
            )(basePath);
        },
        /**
         *
         * @summary Returns a detail of shared dive
         * @param {string} diveId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesByDiveIdGet(diveId: string, options?: any) {
            return SharedDivesApiFp(configuration).apiSharedDivesByDiveIdGet(
                diveId,
                options
            )(basePath);
        },
        /**
         *
         * @summary Creates a shared dive via sharedToken
         * @param {string} sharingToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesBySharingTokenPost(sharingToken: string, options?: any) {
            return SharedDivesApiFp(
                configuration
            ).apiSharedDivesBySharingTokenPost(sharingToken, options)(basePath);
        },
        /**
         *
         * @summary Returns a list of shared dives
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSharedDivesGet(options?: any) {
            return SharedDivesApiFp(configuration).apiSharedDivesGet(options)(
                basePath
            );
        }
    };
};

/**
 * SharedDivesApi - object-oriented interface
 * @export
 * @class SharedDivesApi
 * @extends {BaseAPI}
 */
export class SharedDivesApi extends BaseAPI {
    /**
     *
     * @summary Deletes a shared dive (connection to profile)
     * @param {} diveId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedDivesApi
     */
    public apiSharedDivesByDiveIdDelete(diveId: string, options?: any) {
        return SharedDivesApiFp(
            this.configuration
        ).apiSharedDivesByDiveIdDelete(diveId, options)(this.basePath);
    }

    /**
     *
     * @summary Returns a detail of shared dive
     * @param {} diveId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedDivesApi
     */
    public apiSharedDivesByDiveIdGet(diveId: string, options?: any) {
        return SharedDivesApiFp(this.configuration).apiSharedDivesByDiveIdGet(
            diveId,
            options
        )(this.basePath);
    }

    /**
     *
     * @summary Creates a shared dive via sharedToken
     * @param {} sharingToken
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedDivesApi
     */
    public apiSharedDivesBySharingTokenPost(
        sharingToken: string,
        options?: any
    ) {
        return SharedDivesApiFp(
            this.configuration
        ).apiSharedDivesBySharingTokenPost(sharingToken, options)(
            this.basePath
        );
    }

    /**
     *
     * @summary Returns a list of shared dives
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SharedDivesApi
     */
    public apiSharedDivesGet(options?: any) {
        return SharedDivesApiFp(this.configuration).apiSharedDivesGet(options)(
            this.basePath
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/api.ts